import { useQuery } from '@tanstack/react-query';

import getGiveawayBrief from 'Api/productivity-host/getGiveawayBrief';

import getGiveawayBriefResponse from './model/response/getGiveawayBriefResponse';


const useGetGiveawayBrief = () => {
  return useQuery({
    queryKey: ['giveaway-brief'],
    queryFn: async () => {
      const response = await getGiveawayBrief();

      return getGiveawayBriefResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetGiveawayBrief;
